import React from 'react';
import { Box, Button, Heading, Body, Link, BoxProps } from '@hover/blueprint';

interface ITryItOutProps extends BoxProps {
  title: string;
  body: string;
  cta: {
    title: string;
    url: string;
  };
  isBordered?: boolean;
}

const TryItOut = ({
  title,
  body,
  cta,
  isBordered,
  ...boxProps
}: ITryItOutProps) => (
  <Box
    {...boxProps}
    textAlign="center"
    bgColor="neutral.50"
    w="100%"
    justifyContent="center"
  >
    <Box
      maxWidth="7xl"
      w="100%"
      py="100px"
      borderTop={isBordered ? '1px solid' : undefined}
      borderColor="neutral.300"
      d="block"
    >
      <Heading
        size={{ base: 500, tablet: 600, desktop: 700 }}
        style={{ marginBottom: 8 }}
      >
        {title}
      </Heading>
      <Body mb={4}>{body}</Body>
      <Button
        as={Link}
        href={cta.url}
        maxWidth="255px"
        margin="auto"
        size="large"
        style={{ color: 'white', cursor: 'pointer' }}
      >
        {cta.title}
      </Button>
    </Box>
  </Box>
);

export default TryItOut;
